// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkr-candidate-action__description{font-size:14px;line-height:18px;margin-bottom:32px}`, "",{"version":3,"sources":["webpack://./src/modals/CheckrCandidateAction/style.scss"],"names":[],"mappings":"AAEE,sCACE,cAAA,CACA,gBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
